<template>
  <div class="image-attribution">
    <div class="image-attribution-inner">
      <div
        v-if="authorDescription"
        class="description"
      >
        {{ authorDescription }}
      </div>
      <div
        v-if="authorInfo"
        class="preposition"
      >
        by
      </div>
      <div
        class="author"
        v-html="authorInfo"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'content-image-info',
  props: {
    authorDescription: {
      type: String,
      required: false,
      default: ''
    },
    authorName: {
      type: String,
      required: false,
      default: ''
    },
    authorUrl: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    // show name & link of author if available
    authorDisplay() {
      return this.authorName
    },
    authorInfo(authorName, authorUrl, authorDisplay) {
      if (authorDisplay && this.authorUrl) {
        return `<a href="${this.authorUrl}" target="_blank" rel="noopener noreferrer">${this.authorDisplay}</a>`
      }
      return this.authorDisplay
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';
.image-attribution-inner {
  word-break: break-word;

  .description {
    display: inline;
  }
  div {
    margin: 0;
    display: inline-block;
    &:first-of-type {
      &:first-letter {
        text-transform: uppercase;
      }
    }
  }
}
</style>
